import React from "react";

const IsVerticalContext = React.createContext();

export const IsVerticalProvider = IsVerticalContext.Provider;
export const IsVerticalConsumer = IsVerticalContext.Consumer;

export default IsVerticalContext;
